/*
  ATD - Testimonios 2 — carrusel.
  - Flechas prev/next con loop infinito: en el extremo, hace wrap al otro lado.
  - Auto-hide de flechas y barra de progreso si todas las cards caben sin scroll.
  - Progress bar refleja % de scroll del viewport.
*/

(() => {
  const EDGE = 4; // tolerancia en px para considerar "en el borde".

  const init = (section) => {
    const viewport = section.querySelector('[data-atd-tt2-viewport]');
    const prev = section.querySelector('[data-atd-tt2-prev]');
    const next = section.querySelector('[data-atd-tt2-next]');
    const progress = section.querySelector('[data-atd-tt2-progress]');
    const progressBar = section.querySelector('[data-atd-tt2-progress-bar]');
    if (!viewport) return;

    const cardWidth = () => {
      const first = viewport.firstElementChild;
      if (!first) return viewport.clientWidth;
      const gap = parseFloat(getComputedStyle(viewport).columnGap || '0');
      return first.getBoundingClientRect().width + gap;
    };

    const hasOverflow = () => viewport.scrollWidth > viewport.clientWidth + EDGE;

    const toggleControls = () => {
      const show = hasOverflow();
      if (prev) prev.style.display = show ? '' : 'none';
      if (next) next.style.display = show ? '' : 'none';
      if (progress) progress.style.display = show ? '' : 'none';
      return show;
    };

    const update = () => {
      if (!toggleControls()) return;
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (progressBar && max > 0) {
        const visibleRatio = viewport.clientWidth / viewport.scrollWidth;
        const scrolledRatio = viewport.scrollLeft / max;
        const barWidth = Math.max(visibleRatio * 100, 10);
        const barLeft = scrolledRatio * (100 - barWidth);
        progressBar.style.width = `${barWidth}%`;
        progressBar.style.marginLeft = `${barLeft}%`;
      }
    };

    prev?.addEventListener('click', () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (viewport.scrollLeft <= EDGE) {
        // En el inicio → loop al final.
        viewport.scrollTo({ left: max, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      }
    });

    next?.addEventListener('click', () => {
      const max = viewport.scrollWidth - viewport.clientWidth;
      if (max - viewport.scrollLeft <= EDGE) {
        // En el final → loop al inicio.
        viewport.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        viewport.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      }
    });

    viewport.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    requestAnimationFrame(update);
  };

  const initAll = () => document.querySelectorAll('.atd-testimonials2').forEach(init);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Theme editor: re-init cuando Shopify recarga una sección.
  document.addEventListener('shopify:section:load', (e) => {
    const target = e.target;
    if (!(target instanceof Element)) return;
    target.querySelectorAll?.('.atd-testimonials2').forEach(init);
    if (target.matches?.('.atd-testimonials2')) init(target);
  });
})();
